import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import "echarts";
import ECharts from 'vue-echarts'

import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'

import vue3SeamlessScroll from "vue3-seamless-scroll";


const app = createApp(App);

app
    .use(store)
    .use(router)
    .use(ElementPlus)
    .use(vue3SeamlessScroll)
    .component('v-chart', ECharts)
    .mount("#app");